// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"459":"c41a0dc9","613":"fc21fab9","997":"6ff2e333"}[chunkId] + ".chunk.js";
};